<template>
    <el-dialog
        title="Parsers"
        :visible.sync="showDialog"
        width="70%">
        <div>
            <div class="row">
                <div class="col-sm-12">
                    <table class="table table-striped table-hover">
                        <thead>
                        <tr>
                            <th>Parser</th>
                            <th style="width: 20%">Used by</th>
                            <th style="width: 50%">Notes</th>
                            <th>Example</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="parser in parsers">
                            <td>{{ parser.name }}</td>
                            <td>{{ parser.employers }}</td>
                            <td v-html="parser.description" style="word-break: keep-all;"></td>
                            <td><a :href="url(`admin/settings/feeds/get-parser-example-file?parser_name=${parser.key}`)"
                                   target="_blank">Open</a></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="showDialog = false">Close</el-button>
            </span>
    </el-dialog>
</template>

<script>
export default {
    props: [
        'isOpen',
    ],
    data() {
        return {
            parsers: [],
        };
    },
    mounted() {
        this.refresh();
    },
    computed: {
        showDialog: {
            get() { return this.isOpen; },
            set(val) { this.$emit('close'); }
        }
    },
    methods: {
        refresh() {
            return axios.get(url(`admin/settings/feeds/get-parser-list`))
                        .then(response => {
                            this.parsers = response.data;
                        });
        },
    },
};
</script>

<style scoped>

</style>